function UncheckedIcon(props) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="2" fill="#E8ECEF" />
    </svg>
  );
}

function CheckedIcon(props) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="2" fill="#4D7CFE" />
      <path
        d="M8.6437 13.8429L5.1571 10.3563C4.94763 10.1468 4.94763 9.80718 5.1571 9.59769L5.91567 8.8391C6.12514 8.62961 6.46479 8.62961 6.67426 8.8391L9.023 11.1878L14.0537 6.1571C14.2632 5.94763 14.6029 5.94763 14.8123 6.1571L15.5709 6.91569C15.7804 7.12516 15.7804 7.46479 15.5709 7.67428L9.40229 13.8429C9.1928 14.0524 8.85317 14.0524 8.6437 13.8429Z"
        fill="white"
      />
    </svg>
  );
}

function OkayCheckIcon(props) {
  return (
    <svg
      {...props}
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6437 7.84288L0.157101 4.35628C-0.0523671 4.14681 -0.0523671 3.80718 0.157101 3.59769L0.915668 2.8391C1.12514 2.62961 1.46479 2.62961 1.67426 2.8391L4.023 5.18782L9.05374 0.157101C9.26321 -0.0523671 9.60286 -0.0523671 9.81233 0.157101L10.5709 0.915689C10.7804 1.12516 10.7804 1.46479 10.5709 1.67428L4.40229 7.8429C4.1928 8.05237 3.85317 8.05237 3.6437 7.84288Z"
        fill="white"
      />
    </svg>
  );
}

export { CheckedIcon, UncheckedIcon, OkayCheckIcon };
